//PlaylistsContext.js used to pass Playlists State

import React, { createContext, useContext } from 'react';
import { useInitialData } from '../Playlists/hooks/useInitialData'; // Adjust path as needed

// Create the context
export const PlaylistsContext = createContext();

// Hook to use playlists context
export const usePlaylists = () => {
    console.log('[PlaylistsContext] usePlaylists');
    const context = useContext(PlaylistsContext);
    if (!context) {
        throw new Error('[PlaylistsContext] usePlaylists must be used within a PlaylistsProvider');
    }
    return context;
};

// PlaylistsProvider Component
export const PlaylistsProvider = ({ children }) => {
    // Use the custom hook directly
    const { 
        playlists, 
        setPlaylists, 
        playlistsLoading,
        cleanupLoading,
        isInitializing, // This is the combined const you mentioned
        error 
    } = useInitialData();

    // Context value to share
    const contextValue = {
        playlists,
        setPlaylists,
        playlistsLoading,     // Specific loading for playlist fetching
        cleanupLoading,       // Specific loading for cleanup operations
        isInitializing,       // Combined loading state (const)
        error,
    };

    // Handle loading and error states
    // if (isInitializing) return <div>Loading playlists...</div>;
    // if (error) return <div>Error loading playlists: {error}</div>; // Removed .message since error is already a string

    return (
        <PlaylistsContext.Provider value={contextValue}>
            {children}
        </PlaylistsContext.Provider>
    );
};